<template>
    <div>
        <div>
            <div class="plan_section_" v-if="planValue=='0'">
                <div class="header_">
                    <span>中国大陆计划1</span>
                    <span @click="planDesc[3].unexpand = !planDesc[3].unexpand" 
                        class="h_right_">
                        {{planDesc[3].unexpand ? '展开' : '收起'}}
                        <a-icon :type="planDesc[3].unexpand ? 'down' : 'up'">
                        </a-icon>
                    </span>
                </div>
                <div v-if="!planDesc[3].unexpand" class="content_">
                    <table class="table_">
                        <col width="50%">
                        <col width="50%">
                        <tr><td>保险计划</td><td>计划1</td></tr>
                        <tr><td>保障区域</td><td>中国大陆地区</td></tr>
                        <tr><td>保单年度总限额</td><td>500,000</td></tr>
                        <tr><td>保障地域外紧急医疗</td><td>不在保障范围内</td></tr>
                        <tr><td>医院范围</td><td>公立（含VIP，特需，国际部）</td></tr>
                        <tr><td>昂贵医院赔付比例</td><td>不在保障范围内</td></tr>
                        <tr><td colspan="2" style="text-align:center">住院医疗保险金责任</td></tr>
                        <tr><td>住院医疗保险金保单年度总限额</td><td>50万</td></tr>
                        <tr><td>床位费，膳食费，护理费日限额（最多180日/保单年度）</td><td>1,000元/晚</td></tr>
                        <tr><td>检查检验费保险金额</td><td>每保险年度限2万元</td></tr>
                        <tr><td>治疗费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>医生费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>药品费（含中草药）保险金额</td><td>每次住院限2万元</td></tr>
                        <tr><td>手术费保险金额</td><td>每次住院限10万元</td></tr>
                        <tr><td>加床费日限额</td><td>1,000元/晚</td></tr>
                        <tr><td>重症监护室床位费日限额</td><td>2,500元/晚</td></tr>
                        <tr><td>精神疾病治疗费保险金额（最多90日/保单年）</td><td>不在保障范围内</td></tr>
                        <tr><td>救护车费用</td><td>100%赔付</td></tr>
                        <tr><td colspan="2" style="text-align:center">门诊医疗保险金</td></tr>
                        <tr><td>门诊医疗保单年度总限额</td><td>3万</td></tr>
                        <tr><td>非中草药费保险金额</td><td>每保险年度限6千元</td></tr>
                        <tr><td>中草药保险金额</td><td rowspan="2">每次限300元，每保险年度限10次</td></tr>
                        <tr><td>物理治疗，中医治疗及其他特殊疗效法</td></tr>
                        <tr><td>挂号费/医生诊疗费保险金额</td><td>600元/日</td></tr>
                        <tr><td>治疗费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>每保险年度限6千元</td></tr>
                        <tr><td>门诊手术费</td><td>100%赔付</td></tr>
                        <tr><td>救护车费用</td><td>100%赔付</td></tr>
                        <tr><td>门诊精神疾病保障</td><td>包含/不包含</td></tr>
                        <tr><td colspan="2" style="text-align:center">特殊门诊医疗保险金（门诊肾透析，门诊放化疗）</td></tr>
                        <tr><td>特殊门诊医疗保险金保单年度限额</td><td>10万</td></tr>
                        <tr><td colspan="2" style="text-align:center">耐用医疗设备保险金</td></tr>
                        <tr><td>耐用医疗设备保险金保单年度限额</td><td>每保险年度限1万元</td></tr>
                        <tr><td colspan="2" style="text-align:center">全球紧急救援</td></tr>
                        <tr><td>紧急医疗转送，直系亲属探病及住宿，随行未成年子女回国或居住地，医疗转送回国或居住地，紧急回国或居住地料理直系亲属后事，直系亲属前往处理后事，遗体安排</td><td>不在保障范围内</td></tr>
                    </table>
                </div>
            </div>
            <div class="plan_section_" v-if="planValue=='1'">
                <div class="header_">
                    <span>中国大陆计划2</span>
                    <span @click="planDesc[4].unexpand = !planDesc[4].unexpand" 
                        class="h_right_">
                        {{planDesc[4].unexpand ? '展开' : '收起'}}
                        <a-icon :type="planDesc[4].unexpand ? 'down' : 'up'">
                        </a-icon>
                    </span>
                </div>
                <div v-if="!planDesc[4].unexpand" class="content_">
                    <table class="table_">
                        <col width="50%">
                        <col width="50%">
                        <tr><td>保险计划</td><td>计划2</td></tr>
                        <tr><td>保障区域</td><td>中国大陆地区</td></tr>
                        <tr><td>保单年度总限额</td><td>500,000</td></tr>
                        <tr><td>保障地域外紧急医疗</td><td>不在保障范围内</td></tr>
                        <tr><td>医院范围</td><td>公立（含VIP，特需，国际部）+私立医疗机构</td></tr>
                        <tr><td>昂贵医院赔付比例</td><td>100%赔付</td></tr>
                        <tr><td colspan="2" style="text-align:center">住院医疗保险金责任</td></tr>
                        <tr><td>住院医疗保险金保单年度总限额</td><td>50万</td></tr>
                        <tr><td>床位费，膳食费，护理费日限额（最多180日/保单年度）</td><td>100%赔付</td></tr>
                        <tr><td>检查检验费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>治疗费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>医生费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>药品费（含中草药）保险金额</td><td>100%赔付</td></tr>
                        <tr><td>手术费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>加床费日限额</td><td>100%赔付</td></tr>
                        <tr><td>重症监护室床位费日限额</td><td>100%赔付</td></tr>
                        <tr><td>精神疾病治疗费保险金额（最多90日/保单年）</td><td>100%赔付</td></tr>
                        <tr><td>救护车费用</td><td>100%赔付</td></tr>
                        <tr><td>门诊精神疾病保障</td><td>包含/不包含</td></tr>
                        <tr><td colspan="2" style="text-align:center">门诊医疗保险金</td></tr>
                        <tr><td>门诊医疗保单年度总限额</td><td>7万</td></tr>
                        <tr><td>非中草药费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>中草药保险金额</td><td rowspan="2">100%赔付</td></tr>
                        <tr><td>物理治疗，中医治疗及其他特殊疗效法</td></tr>
                        <tr><td>挂号费/医生诊疗费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>治疗费保险金额</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>门诊手术费</td><td>100%赔付</td></tr>
                        <tr><td>救护车费用</td><td>100%赔付</td></tr>
                        <tr><td colspan="2" style="text-align:center">特殊门诊医疗保险金（门诊肾透析，门诊放化疗）</td></tr>
                        <tr><td>特殊门诊医疗保险金保单年度限额</td><td>25万</td></tr>
                        <tr><td colspan="2" style="text-align:center">耐用医疗设备保险金</td></tr>
                        <tr><td>耐用医疗设备保险金保单年度限额</td><td>100%赔付</td></tr>
                        <tr><td colspan="2" style="text-align:center">全球紧急救援</td></tr>
                        <tr><td>紧急医疗转送，直系亲属探病及住宿，随行未成年子女回国或居住地，医疗转送回国或居住地，紧急回国或居住地料理直系亲属后事，直系亲属前往处理后事，遗体安排</td><td>100%赔付（限中国大陆地区）</td></tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>可选责任:牙科福利</span>
                <span @click="planDesc[0].unexpand = !planDesc[0].unexpand" 
                    class="h_right_">
                    {{planDesc[0].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[0].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[0].unexpand" class="content_">
                <table class="table_">
                    <col width="33%" />
                    <col width="33%" />
                    <col width="33%" />
                    <tr><td>牙科福利年度总限额</td><td colspan="2">2,000/5,000/10,000</td></tr>
                    <tr><td>洗牙/预防治疗</td><td>100%赔付</td><td>100%赔付</td></tr>
                    <tr><td>基本牙科治疗</td><td>80%赔付</td><td>80%赔付</td></tr>
                    <tr><td>重大牙科治疗</td><td>50%赔付</td><td>50%赔付</td></tr>
                </table>
            </div>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>可选责任：体检福利</span>
                <span @click="planDesc[1].unexpand = !planDesc[1].unexpand" 
                    class="h_right_">
                    {{planDesc[1].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[1].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[1].unexpand" class="content_">
                <table class="table_">
                    <col width="33%">
                    <col width="33%">
                    <col width="33%">
                    <tr><td>体检福利年度总限额</td><td colspan="2">3,200/5,000</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选责任：生育福利</span>
                <span @click="planDesc[2].unexpand = !planDesc[2].unexpand" 
                    class="h_right_">
                    {{planDesc[2].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[2].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[2].unexpand" class="content_">
                <table class="table_">
                    <col width="33%">
                    <col width="33%">
                    <col width="33%">
                    <tr><td>生育福利年度总限额</td><td colspan="2">30,000/60,000（首次入保生育等待期10个月）</td></tr>
                    <tr>
                        <td colspan="3">
                            1.仅涵盖涵盖女性主被保险人或作为配偶的女性附属被保险人的分娩费、妊娠并发症治疗费，不涵盖作为子女的附属被保险人的生育相关费用<br>2. 仅赔付等待期后发生的孕产相关的费用。
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .table_ {
        border-color: #eee;
        border: 1px solid #eee;
        width: 100%;
        table-layout: fixed;
        .center_ {
            text-align: center;
        }
        td {
            border: 1px solid #eee;
            text-align: center;
            &:nth-child(1) {
                color: #333;
                font-weight: bold;
                padding-left: 12px;
                text-align: left;
            }
        }
    }
    .plan_section_ {
        margin: 12px 0;
        color: #6e6e6e;
        border-radius: 16px;
        box-shadow: 0rem 0rem 6px 0rem rgba(96, 130, 253, 0.47);
        overflow: hidden;

        .header_ {
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            background: linear-gradient(to bottom, #92a9fc 0%, #6284fe 100%);
            font-size: 14px;
            padding: 12px;
            color: #fff;
            .h_right_ {
                font-size: 12px;
            }
        }
        .pre_ {
            white-space: pre-wrap;
        }
        .content_ {
            margin: 12px;
            font-size: 12px;
        }
        .flex_row_ {
            display: flex;
            align-items: center;
        }
        .place_ {
            visibility: hidden;
        }
        .lh37_ {
            line-height: 36px;
        }
        .left_ {
            border-right: 1px solid #eee;
            border-bottom: 1px solid #eee;
            padding-left: 6px;
            color: #333;
            font-weight: bold;
        }
        .right_ {
            text-align: center;
            border-right: 1px solid #eee;
            border-bottom: 1px solid #eee;
        }
        .line_h_ {
            line-height: 50px;
        }
    }
</style>
<script>
export default {
    props: {
        edit: {
            type: Boolean,
            default: true
        },
        planValue: {
            type: String,
            default: '0'
        }
    },
    data () {
        return {
            planDesc: [
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true }
            ]
        }
    }
}
</script>